import { Modal, Button, notification } from "antd";
import userApi from "../../API/UserAPI";
import { useEffect, useRef, useState } from "react";
import { jwtDecode } from "jwt-decode";
import Lodder from "../Loader/Loader";
import "react-image-crop/dist/ReactCrop.css";
import ReactCrop, {
  centerCrop,
  convertToPixelCrop,
  makeAspectCrop,
} from "react-image-crop";
import { setUserImage } from '../../Reducers/User/UserImage';
import { useDispatch, useSelector } from 'react-redux';
import { State } from "country-state-city";
import { Select } from "antd";
import InputMask from "react-input-mask";
import { LockOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const ASPECT_RATIO = 1;
const MIN_DIMENSION = 200;
const UserProfile = () => {
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();
  const userImage = useSelector((state) => state.userImage);
  const [crop, setCrop] = useState();
  const imgRef = useRef(null);
  const [imageDataUrl, setImageDataUrl] = useState(`data:image/jpeg;base64,${userImage}`)
  const previewCanvasRef = useRef(null);
  const [visible, setVisible] = useState(false);
  const [userId, setUserId] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [states, setStates] = useState("");
  const [phone, setPhone] = useState("");
  const [position, setPosition] = useState("");

  const [modalFirstName, setModalFirstName] = useState("");
  const [modalLastName, setModalLastName] = useState("");
  const [modalEmail, setModalEmail] = useState("");
  const [modalAddress, setModalAddress] = useState("");
  const [modalCity, setModalCity] = useState("");
  const [modalStates, setModalStates] = useState("");
  const [modalPhone, setModalPhone] = useState("");
  const [modalPosition, setModalPosition] = useState("");

  const [show, setShow] = useState(false);
  const [showImageModel, setShowImageModel] = useState(false);
  const GetUserData = async () => {
    setShow(true);
    const token = localStorage.getItem("accessToken");

    const userData = await userApi.getUserById(
      JSON.parse(
        jwtDecode(token)[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"
        ]
      ).id
    );
    setUserId(
      JSON.parse(
        jwtDecode(token)[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"
        ]
      ).id
    );
    setFirstName(userData.firstName);
    setLastName(userData.lastName);
    setEmail(userData.email);
    setAddress(userData.address);
    setCity(userData.city);
    setStates(userData.state);
    setPhone(userData.phone);
    setPosition(userData.position);
    // setImageDataUrl("data:image/jpeg;base64"+ userData.image);


    setModalFirstName(userData.firstName);
    setModalLastName(userData.lastName);
    setModalEmail(userData.email);
    setModalAddress(userData.address);
    setModalCity(userData.city);
    setModalStates(userData.state);
    setModalPhone(userData.phone);
    setModalPosition(userData.position);

    setShow(false);
  };
  useEffect(() => {
    GetUserData();
  }, []);


  const handleUpdate = async () => {
    ValidateFirstName(modalFirstName);
    ValidateLastName(modalLastName);
    if (ValidateFirstName(modalFirstName) && ValidateLastName(modalFirstName)){
      setShow(true);
      setVisible(false);
      const userData = {
        firstName: modalFirstName,
        lastName: modalLastName,
        email: modalEmail,
        address: modalAddress,
        city: modalCity,
        state: modalStates,
        phone: modalPhone,
        position: modalPosition,
        id: userId,
        image: imageDataUrl.split(",")[1]
      };
      const response = await userApi.addUpdateUser(userData);
      if (response) {
        setShow(false);
        setFirstName(modalFirstName);
        setLastName(modalLastName);
        setEmail(modalEmail);
        setAddress(modalAddress);
        setCity(modalCity);
        setStates(modalStates);
        setPhone(modalPhone);
        setPosition(modalPosition);
        dispatch(setUserImage(imageDataUrl.split(",")[1]));
        notification.success({
          message: "Profile updated successfully!",
        });
      } else {
        setShow(false);
        notification.error({
          message: "An error occoured!",
        });
      }
    }
    
  };


  const [imageSrc, setImageSrc] = useState("");
  const [imageError, setImageError] = useState("");
  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      // Read the content of the file using FileReader
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageElement = new Image();
        const imageUrl = reader.result?.toString() || "";
        imageElement.src = imageUrl;
        imageElement.addEventListener("load", (e) => {
          if (imageError) {
            setImageError("");
          }
          const { naturalWidth, naturalHeight } = e.currentTarget;
          if (naturalHeight < MIN_DIMENSION || naturalWidth < MIN_DIMENSION) {
            setImageError("Image must be at least 200 X 200 pixels");
            setImageSrc("");
            return;
          }
        });
        setImageSrc(imageUrl);
      };
      reader.readAsDataURL(file);
    }
  };
  const onImageLoad = (e) => {
    const { width, height } = e.currentTarget;
    const cropWidthInPercent = (MIN_DIMENSION / width) * 100;
    const crop = makeAspectCrop(
      {
        unit: "%",
        width: cropWidthInPercent,
      },
      ASPECT_RATIO,
      width,
      height
    );
    const centeredCrop = centerCrop(crop, width, height);
    setCrop(centeredCrop);
  };
  const setCanvasPreview = (image, canvas, crop) => {
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      throw new Error("No 2d context");
    }
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);
    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";
    ctx.save();
    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;
    ctx.translate(-cropX, -cropY);
    ctx.drawImage(
      image,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight,
      0,
      0,
      image.naturalWidth,
      image.naturalHeight
    );
    ctx.restore();
  };
  const usStates = State.getStatesOfCountry('US').map((state) => ({
    value: state.name,
    label: state.name,
  }));

  const ValidateFirstName = (value) => {
    if (!value.trim()) {
      setFirstNameValidation({
        isValid: false,
        message: "First name is required",
      });
      return false;
    } else if (value.length > 50) {
      setFirstNameValidation({
        isValid: false,
        message: "First name not more than 50 character",
      });
      return false;
    } else {
      setFirstNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };

  const ValidateLastName = (value) => {
    if (!value.trim()) {
      setLastNameValidation({
        isValid: false,
        message: "Last name is required",
      });
      return false;
    } else if (value.length > 50) {
      setLastNameValidation({
        isValid: false,
        message: "Last name not more than 50 character",
      });
      return false;
    } else {
      setLastNameValidation({
        isValid: true,
        message: "",
      });
      return true;
    }
  };


  const [firstNameValidation, setFirstNameValidation] = useState({
    isValid: true,
    message: "",
  });
  const [lastNameValidation, setLastNameValidation] = useState({
    isValid: true,
    message: "",
  });


  const [showPassword, setShowPassword] = useState(false)
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submit, setSubmit] = useState(true);


  const [newPasswordValidation, setNewPasswordValidation] = useState({
    isValid: false,
    message: "",
  });

  const [oldPasswordValidation, setOldPasswordValidation] = useState({
    isValid: false,
    message: "",
  });

  const [confirmPasswordValidation, setConfirmPasswordValidation] = useState({
    isValid: true,
    message: "",
  });

  const ValidateOldPassword = (value) => {
    if (!value.trim()) {
      setOldPasswordValidation({
        isValid: false,
        message: "Old password is required",
      });
    } else {
      setOldPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };

  const ValidateNewPassword = (value) => {
    if (!value.trim()) {
      setNewPasswordValidation({
        isValid: false,
        message: "New password is required",
      });
    } else if (value.length < 6) {
      setNewPasswordValidation({
        isValid: false,
        message: "New password must be at least 6 characters",
      });
    } else {
      setNewPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };

  const ValidateConfirmPassword = (value) => {
    if (!value.trim()) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "Confirm password is required",
      });
    } else if (value !== newPassword) {
      setConfirmPasswordValidation({
        isValid: false,
        message: "New password and confirm password must be same",
      });
    } else {
      setConfirmPasswordValidation({
        isValid: true,
        message: "",
      });
    }
  };

  const handleOldPasswordChange = (event) => {
    setOldPassword(event.target.value);
    ValidateOldPassword(event.target.value);
  };
  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
    ValidateNewPassword(event.target.value);
  };
  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    ValidateConfirmPassword(event.target.value);
  };

  const handleFormSubmit = () => {
    setShow(true);
    setSubmit(false);
    ValidateOldPassword(oldPassword);
    ValidateNewPassword(newPassword);
    ValidateConfirmPassword(confirmPassword);
    if (newPasswordValidation.isValid && oldPasswordValidation.isValid && confirmPasswordValidation.isValid) {
      if (oldPassword === newPassword) {
        setShow(false);
        notification.error({
          message: "New password and old password must be different",
        });
        setSubmit(true);
      }
      else {
        var customerCredentials = {
          oldPassword: oldPassword,
          NewPassword: newPassword
        };
        userApi.changePassword(customerCredentials)
          .then((response) => {
            if (response.status) {
              setOldPassword("");
              setNewPassword("");
              setConfirmPassword("");
              setShow(false);
              notification.success({
                message: "Password changed successfully!",
              });
              setSubmit(true);
            }
          })
          .catch((error) => {
            setShow(false);
            notification.error({
              message: "Incorrect old password",
            });
            setSubmit(true);
          });
      }
    } else {
      setSubmit(true);
      setShow(false);
      setVisible(false);

    }
    setVisible(false);
  };


  return (
    <div>
      <div className="row mx-0 mx-lg-3 mx-0 my-3">
        <div className="col-lg-12">
          <div className="card border-0 shadow w-100 card-span mb-4">
            <div className="card-header property-header py-3">
              <div className="d-flex justify-content-between">
                <h5 className="mb-0 property-heading-card">MY PROFILE</h5>
                <i
                  class="fa-regular fa-pen-to-square edit-icon"
                  onClick={() => {
                    setVisible(true);
                    setImageDataUrl(`data:image/jpeg;base64,${userImage}`);
                  }}
                ></i>
              </div>
            </div>
            <div class="user-profile py-3 px-lg-4 px-2">
              <div className="bio-picture d-flex justify-content-left">
                <img
                  src={`data:image/jpeg;base64,${userImage}`}
                  alt="profile-img"
                  className="img-fluid circle-user"
                ></img>
              </div>
              <div class="bio">
                <p>
                  <span>First Name: </span> {firstName}
                </p>
              </div>
              <div class="bio">
                <p>
                  <span>Last Name: </span> {lastName}
                </p>
              </div>
              <div class="bio">
                <p>
                  <span>Position: </span> {position}
                </p>
              </div>
              <div class="bio">
                <p>
                  <span>Email: </span> {email}
                </p>
              </div>
              <div class="bio">
                <p>
                  <span>Address: </span> {address}
                </p>
              </div>
              <div class="bio">
                <p>
                  <span>State: </span> {states}
                </p>
              </div>
              <div class="bio">
                <p>
                  <span>City: </span> {city}
                </p>
              </div>
              <div class="bio">
                <p>
                  <span>Phone: </span> {phone}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="card border-0 shadow w-100 card-span mb-4">
            <div className="card-header property-header py-3">
              <div className="d-flex justify-content-between login-form">
                <h5 className="mb-0 property-heading-card">CHANGE PASSWORD</h5>
                {/* <Link
                  className="forgot-link"
                  onClick={handleFormSubmit}
                >
                  CHANGE PASSWORD
                </Link> */}
              </div>
            </div>
            <div className="user-profile py-3 px-lg-4 px-2">
              <form>
                <input type="hidden" />
                <div className="row px-3">
                  <div className="mb-3 col-lg-12">
                    <label className="form-label" htmlFor="password">
                      Old Password<span style={{ color: 'red' }}>*</span>
                    </label>
                    <div style={{ position: 'relative' }}>
                      <input
                        className="form-control"
                        type={showPassword ? "text" : "password"}
                        value={oldPassword}
                        onChange={handleOldPasswordChange}
                        style={{ padding: "0.375rem 2.75rem" }}
                      />
                      {showPassword ? <EyeOutlined onClick={() => { setShowPassword(!showPassword) }} style={{ position: 'absolute', top: '11px', right: '11px' }} /> :
                        <EyeInvisibleOutlined onClick={() => { setShowPassword(!showPassword) }} style={{ position: 'absolute', top: '11px', right: '11px' }} />}
                      <LockOutlined class="fa-solid fa-lock" style={{ position: 'absolute', top: '11px', left: '17px' }}></LockOutlined>
                    </div>
                    {!oldPasswordValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {oldPasswordValidation.message}
                      </span>
                    )}
                  </div>
                  <div className="mb-3 col-lg-6">
                    <label className="form-label" htmlFor="password">
                      New Password<span style={{ color: 'red' }}>*</span>
                    </label>
                    <div style={{ position: 'relative' }}>
                      <input
                        className="form-control"
                        type={showNewPassword ? "text" : "password"}
                        value={newPassword}
                        onChange={handleNewPasswordChange}
                        style={{ padding: "0.375rem 2.75rem" }}
                      />
                      {showNewPassword ? <EyeOutlined onClick={() => { setShowNewPassword(!showNewPassword) }} style={{ position: 'absolute', top: '11px', right: '11px' }} /> :
                        <EyeInvisibleOutlined onClick={() => { setShowNewPassword(!showNewPassword) }} style={{ position: 'absolute', top: '11px', right: '11px' }} />}
                      <LockOutlined class="fa-solid fa-lock" style={{ position: 'absolute', top: '11px', left: '17px' }}></LockOutlined>
                    </div>
                    {!newPasswordValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {newPasswordValidation.message}
                      </span>
                    )}
                  </div>
                  <div className="mb-3 col-lg-6">
                    <label className="form-label" htmlFor="password">
                      Confirm Password<span style={{ color: 'red' }}>*</span>
                    </label>
                    <div style={{ position: 'relative' }}>
                      <input
                        className="form-control"
                        type={showConfirmPassword ? "text" : "password"}
                        value={confirmPassword}
                        onChange={handleConfirmPasswordChange}
                        style={{ padding: "0.375rem 2.75rem" }}
                      />
                      {showConfirmPassword ? <EyeOutlined onClick={() => { setShowConfirmPassword(!showConfirmPassword) }} style={{ position: 'absolute', top: '11px', right: '11px' }} /> :
                        <EyeInvisibleOutlined onClick={() => { setShowConfirmPassword(!showConfirmPassword) }} style={{ position: 'absolute', top: '11px', right: '11px' }} />}
                      <LockOutlined class="fa-solid fa-lock" style={{ position: 'absolute', top: '11px', left: '17px' }}></LockOutlined>
                    </div>
                    {!confirmPasswordValidation.isValid && (
                      <span style={{ color: "red" }}>
                        {confirmPasswordValidation.message}
                      </span>
                    )}
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button
                      type="button"
                      className="submit-button mt-3"
                      onClick={handleFormSubmit}
                    >
                      CHANGE PASSWORD
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>

      </div>
      <Modal
        className="custom-ant-modal"
        title="Update Profile"
        visible={visible}
        onCancel={() => {
          setVisible(false);
          GetUserData();
        }}
        footer={[
          <Button
            className="submit-button text-white"
            key="submit"
            type="primary"
            onClick={handleUpdate}
          >
            UPDATE
          </Button>,
          <Button
            className="btn-submit-secondary"
            key="back"
            onClick={() => {
              setFirstNameValidation({
                isValid: true,
                message: "",
              });
              setLastNameValidation({
                isValid: true,
                message: "",
              });
              setVisible(false);
              GetUserData();
              setShowImageModel(false);
              if (fileInputRef.current) {
                fileInputRef.current.value = '';
              }
              setImageSrc('');
            }}

          >
            CANCEL
          </Button>,
        ]}
      >
        <div className="row mx-0 mx-lg-3">
          <div className="col-lg-12">
            <div className="text-center position-relative">
              <img
                src={imageDataUrl === null ? `data:image/jpeg;base64,${userImage}` : imageDataUrl}
                alt="profile-img"
                className="img-fluid circle-user"
              ></img>
              <i
                class="fa-solid fa-camera-retro icon-camera"
                onClick={() => {
                  setShowImageModel(true);
                }}
              ></i>
            </div>

            <form className="row mt-4">
              <div className="col-md-6 mb-2">
                <label className="form-label">First Name<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={modalFirstName}
                  onChange={(event) => {
                    ValidateFirstName(event.target.value);
                    setModalFirstName(event.target.value);
                  }}
                />
                {!firstNameValidation.isValid && (
                  <div style={{ color: "red" }}>
                    {firstNameValidation.message}
                  </div>
                )}

              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Last Name<span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  className="form-control"
                  value={modalLastName}
                  onChange={(event) => {
                    ValidateLastName(event.target.value);
                    setModalLastName(event.target.value);
                  }}
                />
                {!lastNameValidation.isValid && (
                  <div style={{ color: "red" }}>
                    {lastNameValidation.message}
                  </div>
                )}
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  value={modalEmail}
                  onChange={(event) => {
                    setModalEmail(event.target.value);
                  }}
                  disabled
                />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Position</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalPosition}
                  onChange={(event) => {
                    setModalPosition(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalAddress}
                  onChange={(event) => {
                    setModalAddress(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  value={modalCity}
                  onChange={(event) => {
                    setModalCity(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">State</label>
                <Select
                  type="text"
                  className=""
                  value={modalStates}
                  options={usStates}
                  onChange={(selectedOption) => {
                    setModalStates(selectedOption);
                  }}
                />
              </div>
              <div className="col-md-6 mb-2">
                <label className="form-label">Phone</label>
                <InputMask
                  mask="(999) 999-9999"
                  type="text"
                  className="form-control"
                  value={modalPhone}
                  onChange={(event) => {
                    setModalPhone(event.target.value);
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </Modal>
      <Modal
        height={700}
        className="custom-ant-modal"
        title="Update Profile Image"
        visible={showImageModel}
        onCancel={() => {
          setShowImageModel(false);
        }}
        footer={[
          <Button
            className="submit-button text-white"
            key="submit"
            type="primary"
            onClick={() => {
              if (imgRef.current !== null) {
                setCanvasPreview(
                  imgRef.current,
                  previewCanvasRef.current,
                  convertToPixelCrop(
                    crop,
                    imgRef.current.width,
                    imgRef.current.height
                  )
                );
                setImageDataUrl(previewCanvasRef.current.toDataURL('image/jpeg'))
              }
              setShowImageModel(false);
            }}
          >
            UPDATE
          </Button>,
          <Button
            className="btn-submit-secondary"
            key="back"
            onClick={() => {
              setShowImageModel(false);
              if (fileInputRef.current) {
                fileInputRef.current.value = '';
              }
              setImageSrc('')
            }}
          >
            CANCEL
          </Button>,
        ]}
      >
        <div>
          <input
            type="file"
            id="fileInput"
            accept=".jpg, .png, .jpeg, image/jpeg, image/png"
            onChange={handleFileChange}
            className="my-3"
            ref={fileInputRef}
          />
          {imageError && <p style={{ color: "red" }}>{imageError}</p>}
          {imageSrc && (
            <div>
              <ReactCrop
                crop={crop}
                circularCrop
                keepSelection
                aspect={ASPECT_RATIO}
                minWidth={MIN_DIMENSION}
                onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
              >
                <img
                  ref={imgRef}
                  src={imageSrc}
                  alt="Upload"
                  style={{ maxHeight: "70vh" }}
                  onLoad={onImageLoad}
                />
              </ReactCrop>
            </div>
          )}
          {crop && (
            <canvas
              className="mt-4"
              ref={previewCanvasRef}
              style={{
                display: "none",
                border: "1px solid black",
                objectFit: "contain",
                width: 150,
                height: 150,
              }}
            ></canvas>
          )}
        </div>
      </Modal>
      <Lodder show={show} />
    </div>
  );
};
export default UserProfile;
